export default "<section class=\"content\">\n    <div>\n        <div class=\"box\">\n            dev portal\n        </div>\n    </div>\n</section>\n";